export default "/static/webpack/media/undraw_shared_goals.86c9162f.svg";